import { render, staticRenderFns } from "./Add_statuses.vue?vue&type=template&id=b1dd8fb0&"
import script from "./Add_statuses.vue?vue&type=script&lang=js&"
export * from "./Add_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports